// @flow

import React, { Component } from 'react';

import type { Element } from 'react';

import _ from 'lodash';
import mapSeries from 'async/mapSeries';
import localforage from 'localforage';
import FlatButton from 'material-ui/FlatButton';
import Toggle from 'material-ui/Toggle';
import Alert from 'react-s-alert';
import {Icon} from 'react-fa';

import XDialog from './XDialog.jsx';
import App from './App.jsx';

import {no_rclick, takeDir, abrev, get_predio, get_service_part, show_service, takeFilename, noop} from './utils.js';
import {fetch_dir, get_all_services, get_ms_of_dir, copy_culti} from './fetch_things.js';
import {load_stats} from './show_stats.js';
import image_mix from './image_mix.js';
import get_order from './orden.js';

import type {T_Item, T_Node, T_ErrOk} from './types.js';
import type {T_Stats} from './Stats.jsx';

import './css/DialogThematic.css';


type T_DialogThematicProps = {
  app               : App,
  culti             : string,
  window_drag       : boolean,
  show_escalas_below: boolean
};



type T_Tab = {
  name: string,
  pngs: Array<T_Item>,
};



type T_DialogThematicState = {
  tabs    : Array<T_Tab>,
  selected: Array<string>,
  waiting : boolean
};



export default class DialogThematic extends Component<T_DialogThematicProps, T_DialogThematicState> {
  toggle_png    : (ev: SyntheticEvent<*>) => void;
  render_png    : (item: T_Item) => Element<string>;
  render_tab    : (tab : T_Tab ) => Element<string>;
  make          : () => void;
  close         : () => void;
  toggle_escalas: () => void;
  
  
  constructor(props: T_DialogThematicProps) {
    super(props);
    
    this.state = {
      tabs    : [],
      selected: [],
      waiting : false
    };
    
    this.toggle_png     = this.toggle_png.bind(this);
    this.render_png     = this.render_png.bind(this);
    this.render_tab     = this.render_tab.bind(this);
    this.make           = this.make.bind(this);
    this.close          = this.close.bind(this);
    this.toggle_escalas = this.toggle_escalas.bind(this);
    
    this.props.app.dialog_thematic = this;
  }
  
  
  
  componentWillUnmount() {
    this.props.app.dialog_thematic = null;
  }
  
  
  
  good_png(node: T_Node, ss: Array<T_Stats>): boolean {
    return (
      node.Type === 'png' &&
      node.File.indexOf('Mapa_Tematico_') !== 0 &&
      ss.find(st => st.png === node.File) != null
    );
  }
  
  
  
  componentDidMount() {
    if (this.props.app.tree != null) {
      const {tree}       = this.props.app,
            {app, culti} = this.props;
      
      get_all_services(app, get_predio(culti), (cultis: Array<string>) => {
        mapSeries(cultis, (culti_path, callback) => {
          const dir = takeDir(culti_path);
          
          fetch_dir(app, dir, (result: Array<T_Node> | string) => {
            if (typeof result === 'string') {
              console.log('DialogThematic init:', result);
            }
            else if (result instanceof Array) {
              const nodes: Array<T_Node> = result;
              
              load_stats(app, culti_path, false, false, true, (ss: Array<T_Stats>) => {
                const tab = {
                  name: get_service_part(culti_path),
                  pngs: nodes.filter(node => this.good_png(node, ss)).map(get_order)
                };
                
                const next = () => callback(null, tab);
                
                const preamble = () => {
                  tree.open_path(dir, next);
                };
                
                if (tab.name === 'Desconocido') {
                  get_ms_of_dir(app, dir, (mb_shape) => {
                    if (typeof mb_shape !== 'string') {
                      const ms_file = takeFilename(mb_shape.shpfile);
                      
                      if (ms_file.indexOf('ms_' ) === 0) { tab.name = 'ADN suelo'               ; }
                      if (ms_file.indexOf('mf_' ) === 0) { tab.name = 'ADN foliar'              ; }
                      if (ms_file.indexOf('mfs_') === 0) { tab.name = 'Análisis físico de suelo'; }
                    }
                    else if (tab.pngs.length === 1) {
                      tab.name = tab.pngs[0].label;
                    }
                    else {
                      // FIXME: determina el nombre del puto servicio
                    }
                    
                    preamble();
                  });
                }
                else {
                  preamble();
                }
              });
            }
          });
        }, (err, tabs: Array<T_Tab>) => {
          if (tabs.length === 0) {
            return Alert.error('No hay servicios en esta carpeta.');  // este error sería raro...
          }
          
          if (this.get_total_pngs(tabs) <= 1) {
            return Alert.error('No hay elementos para combinar.');
          }
          
          this.setState({tabs, selected: this.get_loaded(tabs)}, () => {
            app.setState({disable_sidebar: true, wait: false});
          });
        });
      });
    }
  }
  
  
  
  componentDidUpdate(prevProps: T_DialogThematicProps, prevState: T_DialogThematicState) {
    if (! _.isEqual(prevState.selected, this.state.selected)) {
      console.log('dialog_thematic componentDidUpdate', this.state.selected.map(takeFilename));
    }
  }
  
  
  
  reset_make(): void {
    this.setState({waiting: false});
  }
  
  
  
  make(): void {
    if (this.state.selected.length <= 1) {
      return Alert.warning('Seleccione al menos dos imágenes.');
    }
    
    const {app} = this.props,
          dpred = get_predio(this.state.selected[0]),
          dir   = `${dpred}/Mapas_tematicos`;
    
    this.setState({waiting: true});
    
    app.mkdir(dir, (response_mkdir: T_ErrOk) => {
      if (response_mkdir.error && typeof response_mkdir.error === 'string') {
        return Alert.error(response_mkdir.error);
      }
      else if (response_mkdir.ok && typeof response_mkdir.ok === 'string') {
        copy_culti(app, this.props.culti, dir, (result_cp) => {
          image_mix(app, dir, this.state.selected, (result) => {
            if (typeof result === 'string') {
              const out = (result: string);
              
              const end = () => {
                app.sidebar.setState({bt_active: 'Mapas'}, () => {
                  app.sidebar.show_tree();
                });
                
                app.reload_dir(dpred, (res1) => {
                  app.reload_dir(dir, (res2) => {
                    const item_png = app.get_item_png(out);
                    
                    if (item_png != null) {
                      const item = item_png;
                      
                      item.open(() => {
                        item.scroll();
                        
                        const fathers = {fathers: this.state.selected, author: app.state.user.user_name};
                        
                        app.post_json(fathers, `${item.props.node.Path}.fathers.json`, (res_json) => {
                          app.setState({show_dialog_thematic: false, disable_sidebar: false});
                          
                          if (res_json.error && typeof res_json.error === 'string') {
                            Alert.error(res_json.error);
                          }
                        });
                      });
                    }
                  });
                });
              };
              
              if (app.four_maps != null) {
                app.four_maps.activate_map(0, end);
              }
              else {
                end();
              }
            }
            else if (typeof result.error === 'string') {
              Alert.error(`Error: ${result.error}`);
              
              if (result.error.indexOf('distintas dimensiones') !== -1) {
                // FIXME: INFORMAR LA MÁXIMA DIFERENCIA DE LOS EXTENTS DE LOS INSUMOS.
                // TODO:  HAZ UN SERVICIO ESPECIAL PARA SACAR EXTENTS
              }
              
              this.reset_make();
            }
          });
        });
      }
    });
  }
  
  
  
  close(): void {
    const {app} = this.props;
    
    app.close_mt_view(() => {
      if (app.tree != null) {
        app.tree.unclick_all();
      }
      
      app.setState({show_dialog_thematic: false, disable_sidebar: false}, () => {
        _.delay(() => {
          if (! app.map_ui.map.last_shp_path()) {    // si aún no se ha restaurado algún mapa...
            localforage.getItem(`${app.state.user.user_name}.last_culti`).then((culti_path: ?string) => {
              if (culti_path) {
                const item_shp = app.get_item_shp(culti_path);
                
                if (item_shp != null) {
                  item_shp.open();
                }
              }
            });
          }
          
          _.delay(() => app.refresh_items(noop), 500);
        }, 500);
      });
    });
  }
  
  
  
  toggle_png(ev: SyntheticEvent<*>): void {
    const {path} = ev.currentTarget.dataset,
          {app}  = this.props;
    
    if (app.four_maps != null) {
      const {four_maps} = app;
      
      if (_.includes(this.state.selected, path)) {
        this.setState({selected: _.cloneDeep(this.state.selected).filter(sel_path => sel_path !== path)}, () => {
          four_maps.kill_low_image(path, noop);
        });
      }
      else {
        four_maps.add_low_image(path, () => {
          four_maps.get_low_images((selected: Array<string>) => {
            this.setState({selected});
          });
        });
      }
    }
  }
  
  
  
  render_png(item: T_Item, num: number): Element<string> {
    const path = {'data-path': item.Path};
    
    return (
      <div className='dtheme_png' key={num} {...path} onClick={this.toggle_png}>
        <Icon name={_.includes(this.state.selected, item.Path) ? 'check-square-o' : 'square-o'} />
        
        {abrev(item.label, 12)}
      </div>
    );
  }
  
  
  
  toggle_escalas(): void {
    this.props.app.setState({show_escalas_below: ! this.props.app.state.show_escalas_below});
  }
  
  
  
  get_loaded(tabs: Array<T_Tab>): Array<string> {
    return _.flatten(tabs.map((tab: T_Tab) => {
      return tab.pngs.map(node => node.Path).filter(path => this.props.app.map_ui.map.is_loaded(path));
    }));
  }
  
  
  
  get_total_pngs(tabs: Array<T_Tab>): number {
    return _.sumBy(tabs, tab => tab.pngs.length);
  }
  
  
  
  render_tab(tab: T_Tab, index: number): Element<string> {
    const ps = _.cloneDeep(tab.pngs),
          gs = [];
    
    while (ps.length > 0) {
      gs.push(ps.splice(0, 4));
    }
    
    return (
      <div className='dtheme_group' key={index}>
        <p>
          {show_service(tab.name)}:
        </p>
        
        {gs.map((pngs, num) => {
          return (
            <div key={num}>
              {pngs.map(this.render_png)}
            </div>
          );
        })}
      </div>
    );
  }
  
  
  
  render() {
    if (this.state.tabs.length === 0 || this.get_total_pngs(this.state.tabs) <= 1) {
      return null;
    }
    
    const {app} = this.props,
          tt   = 'Mapa temático',
          ctl  = 'show_dialog_thematic',
          st   = {width: 500, height: 336},
          ff   = {font: app.favorite_font()},
          drag = this.props.window_drag;
    
    return (
      <XDialog name='dthematic' title={tt} father={app} state_ctl={ctl} drag={! drag} style={st} no_close={true} {...ff}>
        <p className='dtheme_t'>
          Escoja un máximo de tres elementos:
        </p>
        
        <div className='dtheme_scroll'>
          {this.state.tabs.filter(tab => tab.pngs.length > 0).map(this.render_tab)}
        </div>
        
        <table>
          <tbody>
            <tr>
              <td>
                <Toggle
                  label='Mostrar escalas'
                  labelPosition='right'
                  toggled={this.props.show_escalas_below}
                  onToggle={this.toggle_escalas}
                  style={{width: '150px'}}
                />
              </td>
              
              <td>
                <FlatButton
                  label='Cancelar'
                  primary={true}
                  onContextMenu={no_rclick}
                  onClick={this.close}
                />
              </td>
              
              <td>
                {this.state.waiting ?
                  <Icon name='spinner' spin={true} pulse={true} />
                :
                  <FlatButton
                    label='Crear'
                    primary={true}
                    onContextMenu={no_rclick}
                    onClick={this.make}
                    disabled={this.state.selected.length < 2}
                  />
                }
              </td>
            </tr>
          </tbody>
        </table>
      </XDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/DialogThematic.jsx